import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { NOTIFICATION_EVENT_TYPES } from '../../../features/Inbox/constants';
import { useInboxFeature } from '../../../features/Inbox/hooks';
import { getEventsFilter } from '../../../features/Inbox/utils/filters';
import { apiClient, getEndpoints } from '../../common';
import {
	NOTIFICATION_UNREAD_COUNT_NAMESPACE,
	notificationUnreadCountQueryKeyFactory,
} from './constants';

export function useUnreadNotificationCount() {
	const { events, isInclusive } = useInboxFeature();
	const eventsFilter = getEventsFilter(
		NOTIFICATION_EVENT_TYPES,
		events,
		isInclusive
	);

	const queryKey = useMemo(
		() => [
			...notificationUnreadCountQueryKeyFactory.all(),
			{ events: eventsFilter },
		],
		[eventsFilter]
	);

	const queryFn = async () => {
		const url = getEndpoints(NOTIFICATION_UNREAD_COUNT_NAMESPACE).root();
		const { data } = await apiClient.get(url, {
			params: eventsFilter ? { events: eventsFilter } : {},
		});
		return data;
	};

	return useQuery({
		queryKey,
		queryFn,
		select: (response: { count: number }) => response.count,
		refetchIntervalInBackground: false,
		refetchInterval: 1000 * 60 * 10, // 10 minutes
		refetchOnWindowFocus: true,
		staleTime: 1000 * 60 * 5,
	});
}
